
import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';

import {
    BsPlayFill as PlayArrow, BsPause as Pause, BsVolumeUp as VolumeUp, BsVolumeOff as VolumeOff,
    BsFullscreen as Fullscreen,
    BsDownload,
    BsCloudDownloadFill,
    BsVolumeOffFill,
    BsVolumeUpFill,
    BsSpeedometer,
    BsX,
    BsCalendar
} from "react-icons/bs";

import {
    Box, Slider, IconButton, Stack, Select, MenuItem, Typography
} from '@mui/material';


const VideoPlayer2 = ({ src, selectedCamera, date, onAction = () => { }, handleVideoEnd = () => { } }) => {
    const videoRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [volume, setVolume] = useState(1);
    const [muted, setMuted] = useState(false);
    const [progress, setProgress] = useState(0);
    const [playbackRate, setPlaybackRate] = useState(1);
    const [dynaUrl, setDynaUrl] = useState();
    const [day, setDay] = useState(1);

    useEffect(() => {
        let url = `${axios.defaults.baseURL}video/?camera=${selectedCamera?.id}&date=${date}&days=${day}`
        // url = `https://demo.widelapse.com/api/video/?camera=13&date=2026-01-16T10:38:05&days=${day}`
        setDynaUrl(url)
        // const video = videoRef.current;
        // const handleTimeUpdate = () => {
        //     setProgress((video.currentTime / video.duration) * 100 || 0);
        // };
        // video.addEventListener('timeupdate', handleTimeUpdate);
        // return () => video.removeEventListener('timeupdate', handleTimeUpdate);

    }, [day]);

    const togglePlay = () => {
        const video = videoRef.current;
        if (video.paused) {
            video.play();
            setPlaying(true);
        } else {
            video.pause();
            setPlaying(false);
        }
    };

    const handleVolumeChange = (_, value) => {
        const vol = Array.isArray(value) ? value[0] : value;
        videoRef.current.volume = vol;
        setVolume(vol);
        setMuted(vol === 0);
    };

    const toggleMute = () => {
        videoRef.current.muted = !muted;
        setMuted(!muted);
    };

    const handleSeek = (_, value) => {
        const video = videoRef.current;
        const newTime = (Array.isArray(value) ? value[0] : value) * video.duration / 100;
        video.currentTime = newTime;
        setProgress((newTime / video.duration) * 100);
    };

    const handleSpeedChange = (event) => {
        const rate = parseFloat(event.target.value);
        videoRef.current.playbackRate = rate;
        setPlaybackRate(rate);
    };

    // const handleDownload = () => {
    //     const url = data?.video_urls?.[0];       
    //     const link = document.createElement("a");
    //     link.href = url;       
    //     link.setAttribute("download", `${download_name}.mp4`);       
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };

    // const handleDownload = async () => {
    //     const url = data?.video_url;
    //     if (!url) return;

    //     try {
    //         const res = await fetch(url);
    //         const blob = await res.blob();
    //         const blobUrl = URL.createObjectURL(blob);

    //         const link = document.createElement("a");
    //         link.href = blobUrl;
    //         link.download = `${download_name}.mp4`;

    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         URL.revokeObjectURL(blobUrl);

    //     } catch (err) {
    //         console.error("Download failed:", err);
    //     }
    // };
    const handleDownload = () => { }

    return (<>
        <Box sx={{ width: '100%', mx: 'auto', position: 'relative' }}>
            <Box sx={{
                mx: 'auto', left: 0, pt: 10,
                position: 'absolute', zIndex: 999, px: 4, width: 1,
            }}>
                <Box display={'flex'} alignItems={'start'} gap={1}>
                    {[undefined, 7, 30].map((d) => <Box className="box active"
                        onClick={() => { setDay((d || 1)); }}
                        sx={{
                            fontSize: 12, minWidth: 110, textWrap: 'nowrap',
                            background: '#d7d7d7f0', px: 2, py: 1, borderRadius: 2
                        }}><BsCalendar /> Last {d} Day</Box>)}
                    <Box width={1} />
                    <Box>
                        <Box className="box hover" sx={{ fontSize: 12, background: '#000000e0', px: 2, py: 1, borderRadius: 2 }}>
                            <IconButton sx={{ background: 'black', color: '#ffd80c', p: 0 }} onClick={() => onAction("close")}>
                                <BsX fontSize={28} />
                            </IconButton>
                        </Box>
                    </Box>
                </Box>

            </Box>
            <Box sx={{
                py: 0, width: '45%', mx: 'auto', left: 0, right: 0,
                background: '#00000073', position: 'absolute', zIndex: 999,
                borderRadius: '0px 0px 10px 10px', p: 1
            }}>
                <Box sx={{ px: 1, width: 1, pt: 2 }}>
                    <Slider
                        sx={{ color: 'white', width: 1, py: 0, }}
                        value={progress}
                        onChange={handleSeek}
                    />
                    <Stack direction="row" sx={{ width: 1, py: 0 }} spacing={1} alignItems="center" >
                        <IconButton onClick={togglePlay} sx={{ background: 'black', color: '#ffd80c', p: 0.5, }}>
                            {playing ? <Pause fontSize={20} /> : <PlayArrow sx={{ ml: 0.4, my: 0.2 }} fontSize={20} />}
                        </IconButton>
                        <Box sx={{ width: 1 }}></Box>

                        <IconButton sx={{ background: 'black', color: '#ffd80c', p: 0.6 }} onClick={toggleMute}>
                            {muted || volume === 0 ? <BsVolumeOffFill fontSize={18} /> : <BsVolumeUpFill fontSize={18} />}
                        </IconButton>

                        <Slider
                            value={volume}
                            min={0}
                            max={1}
                            step={0.01}
                            sx={{ color: 'white', width: 100 }}
                            onChange={handleVolumeChange}
                        />
                        <Select
                            renderValue={() => <IconButton sx={{ background: 'black', color: '#ffd80c', p: 1 }} >
                                <BsSpeedometer fontSize={14} />
                            </IconButton>}
                            value={playbackRate}
                            onChange={handleSpeedChange}
                            size="small"
                            variant="standard"
                            sx={{
                                minWidth: 80, color: 'white', p: 0, fontSize: 13, '& .MuiSelect-select': {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: 0,
                                },
                            }}
                        >
                            {[0.5, 1, 1.5, 2].map((rate) => (
                                <MenuItem key={rate} value={rate}>
                                    {rate}x
                                </MenuItem>
                            ))}
                        </Select>
                        <IconButton sx={{ background: 'black', color: '#ffd80c', p: 1 }} onClick={() => handleDownload()}>
                            <BsCloudDownloadFill fontSize={13} />
                        </IconButton>
                        <IconButton sx={{ background: 'black', color: '#ffd80c', p: 1 }} onClick={() => videoRef.current.requestFullscreen()}>
                            <Fullscreen fontSize={13} />
                        </IconButton>

                    </Stack>
                </Box>
            </Box>
            <img src={dynaUrl || undefined} width="100%" key={day} />
            <video
                ref={videoRef}
                src={src || undefined}
                width="100%"
                style={{ borderRadius: 2 }}
                onEnded={() => { handleVideoEnd(videoRef) }}
            />
        </Box>
    </>
    );
};

export default VideoPlayer2;
